import {
	UsageModelEnum,
	UsageTypeEnum
}                      from '@app/modules/usage/models/common-usage.model';
import { ProductEnum } from '@core/interfaces/common.interfaces';

// ENUMS #############################################################
// API enums *********************************************************
export enum ReportStatusEnum {
	FAILED = 'failed',
	PROCESSING = 'processing',
	SUBMITTED = 'submitted',
	SUCCESS = 'success'
}

// UI enums *********************************************************
// report
export enum ReportTypeEnum {
	ARCHIVING = 'archiving',
	CLOUD = 'cloud',
	CUSTOMER = 'customer',
	DATA = 'data',
	DATA_INTEGRITY = 'dataIntegrity',
	DETAILED = 'detailed',
	ENTITY = 'entity',
	TOKEN = 'token'
}

// INTERFACES ########################################################
// UI interfaces *****************************************************
export interface IReportFilename {
	entityId: string;
	product: ProductEnum;
	reportType: ReportTypeEnum;
	usageModel: UsageModelEnum;
	usageType: UsageTypeEnum;
	usagePeriod: string;
}

// TYPES #############################################################
export type ReportFilenameType = ( keyof IReportFilename )[];

// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
export class ReportStatusTMO {
	public status: ReportStatusEnum = undefined;

	public error?: string = undefined;
}

export class ReportStatus extends ReportStatusTMO {}
